/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Mark_All_ReadInputs */

const en_notifications_mark_all_read = /** @type {(inputs: Notifications_Mark_All_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark all read`)
};

const pt_br2_notifications_mark_all_read = /** @type {(inputs: Notifications_Mark_All_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar todas como lidas`)
};

/**
* | output |
* | --- |
* | "Mark all read" |
*
* @param {Notifications_Mark_All_ReadInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_mark_all_read = /** @type {((inputs?: Notifications_Mark_All_ReadInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Mark_All_ReadInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_mark_all_read(inputs)
	return pt_br2_notifications_mark_all_read(inputs)
});